import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = () => {
  return (
    <div className="text-center mb-8">
      <Link to="/" className="inline-flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl shadow-lg" style={{ background: 'linear-gradient(135deg, #FF6B00, #FF8C35)' }}>
          <Icon name="Zap" size={28} color="white" />
        </div>
        <span className="text-2xl font-bold" style={{ fontFamily: "'Inter Tight', sans-serif", color: '#E8EAED' }}>FormForge</span>
      </Link>

      <div className="space-y-2">
        <h1 className="text-3xl font-bold" style={{ fontFamily: "'Inter Tight', sans-serif", color: '#E8EAED' }}>Welcome Back</h1>
        <p className="text-lg" style={{ color: '#6B7280' }}>Continue your wellness journey with personalized health tracking</p>
      </div>

      <div className="mt-6 p-4 rounded-lg" style={{ background: 'rgba(0,212,255,0.08)', border: '1px solid rgba(0,212,255,0.2)' }}>
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Icon name="Info" size={16} style={{ color: '#00D4FF' }} />
          <span className="text-sm font-medium" style={{ color: '#00D4FF' }}>Demo Account</span>
        </div>
        <p className="text-xs" style={{ color: '#6B7280' }}>
          Use <strong style={{ color: '#E8EAED' }}>demo@vitaltracker.com</strong> / <strong style={{ color: '#E8EAED' }}>demo123</strong> to explore the app
        </p>
      </div>
    </div>
  );
};

export default WelcomeHeader;